<template>
  <div>
    <navbar :links="links" />
    <div class="mt-4">
      <v-layout
        align-center
        class="grow-1 title"
      >
        <h3>
          <v-icon
            medium
            class="mr-2 grey--text"
          >
            restaurant
          </v-icon>
          {{ $t('menus') }}
        </h3>
      </v-layout>
      <div
        class="
          grey--text
          text--darken-2
          mt-2
          subheading
          nowrap-overflow-ellipsis
        "
      >
        {{ $t('menusPageHint') }}
      </div>
    </div>
    <!-- Creating Menus demo animation -->
    <v-layout
      v-if="settingUpDemo"
      class="mt-5"
      justify-center
      align-center
    >
      <v-progress-circular
        :size="32"
        width="3"
        indeterminate
        class="msr--text"
      />
      <div
        class="grey--text text--darken-2 ml-4"
        style="font-size: 1.5em; font-weight: normal"
      >
        {{ $t('menuDemoIsBeingSetupPleaseWait') }}
      </div>
    </v-layout>
    <!-- Menus -->
    <v-layout
      align-center
      wrap
      class="mt-4"
    >
      <div
        v-for="menu in menus"
        :key="menu.id"
        class="full-width mb-5"
      >
        <v-layout justify-center />
        <div
          class="headline"
          style="font-size: larger"
        >
          {{ menu.name }}
        </div>
        <v-layout
          align-center
          wrap
        >
          <v-flex sm6>
            <v-card
              style="border-radius: 4px"
              class="mt-3 mr-3 pa-3 full-height"
              hover
              :to="{name: 'menuitems', params: {menuId: menu.id}}"
              :title="$t('menuItemsSubheader')"
            >
              <v-layout
                align-center
                justify-center
                class="full-height"
              >
                <v-icon
                  medium
                  class="mr-3 grey--text"
                >
                  fastfood
                </v-icon>
                <span class="title">{{ $t('menuItems') }}</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex sm3>
            <v-card
              style="border-radius: 4px"
              class="mt-3 mr-3 pa-3 full-height"
              hover
              :to="{name: 'menucategories', params: {menuId: menu.id}}"
              :title="$t('menuCategoriesSubheader')"
            >
              <v-layout
                align-center
                justify-center
                class="full-height"
              >
                <v-icon
                  medium
                  class="mr-3 grey--text"
                >
                  menu_book
                </v-icon>
                <span class="title">{{ $t('menuCategories') }}</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex sm3>
            <v-card
              style="border-radius: 4px"
              class="mt-3 mr-3 pa-3 full-height"
              hover
              :to="{name: 'menuadditives', params: {menuId: menu.id}}"
              :title="$t('menuAdditivesSubheader')"
            >
              <v-layout
                align-center
                justify-center
                class="full-height"
              >
                <v-icon
                  medium
                  class="mr-3 grey--text"
                >
                  info
                </v-icon>
                <span class="title">{{ $t('menuAdditives') }}</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-layout>
  </div>
</template>

<script>
import store from '@/store';
import router from '@/router';

import Navbar from '@/components/Navbar';

export default {
  components: {
    Navbar,
  },
  data() {
    return {
      links: ['dashboard', 'menus'],
      loading: false,
      settingUpDemo: false,
    };
  },
  computed: {
    menus() {
      return this.$store.state.common.menus;
    },
    menusHaveBeenFetched() {
      return !!this.$store.state.common.menusLastFetchedAt;
    },
    hasAtLeastOneMenu() {
      return this.menus.length > 0;
    },
  },
  created() {
    this.fetchMenus();
  },
  methods: {
    fetchMenus() {
      this.loading = true;
      this.$store
        .dispatch('LIST_MENUS')
        .then(() => {
          this.maybeSetupDemo();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    maybeSetupDemo() {
      if (this.menusHaveBeenFetched && this.hasAtLeastOneMenu) {
        return;
      }

      this.settingUpDemo = true;
      this.$api
        .setupMenuDemoForUserWorkspace()
        .then((response) => {
          const menuId = response.data.menu_id;
          if (!!menuId) {
            this.$router.push({
              name: 'menuitems',
              params: {menuId: menuId},
            });
          }
        })
        .finally(() => {
          this.settingUpDemo = false;
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    // If we have exactly one Menu (and it is already fetched),
    // redirect to its MenuItems list directly, hiding this Menu list
    // effectively.
    if (store.state.common.menus.length == 1) {
      router.push({
        name: 'menuitems',
        params: {menuId: store.state.common.menus[0].id},
      });
      return;
    }

    next();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Menus.vue